<template>
  <div :class="$style.container">
    <div :class="$style.section">
      <slot name="left" />
    </div>
    <div :class="$style.section">
      <slot name="right" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'DeviceSetupSection',
};
</script>

<style scoped module>
.container {
  display: flex;
}

.section {
  height: 95vh;
  max-height: 95vh;
  width: 50%;
}
</style>
